import {
  useInfiniteQuery,
  type InfiniteData,
  type UseInfiniteQueryResult,
} from "@tanstack/react-query";
import { useApi } from "@platform/api";

import type { ConsultingRfpTimelineResponse } from "./types";

const RFP_TIMELINE_PAGE_SIZE = 20;

export const consultingRfpTimelineQueryKey = (brokerId?: string) =>
  ["consulting", "rfpTimeline", brokerId ?? null] as const;

export function useConsultingRfpTimelineQuery({
  brokerId,
  enabled,
}: {
  brokerId?: string;
  enabled: boolean;
}): UseInfiniteQueryResult<InfiniteData<ConsultingRfpTimelineResponse>> {
  const axiosInstance = useApi();

  return useInfiniteQuery({
    queryKey: consultingRfpTimelineQueryKey(brokerId),
    queryFn: ({ pageParam }) =>
      axiosInstance
        .get<ConsultingRfpTimelineResponse>(
          brokerId
            ? `/consulting/v1/brokers/${brokerId}/rfps`
            : "/consulting/v1/rfps",
          { params: { page: pageParam, limit: RFP_TIMELINE_PAGE_SIZE } },
        )
        .then((response) => response.data),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    enabled,
  });
}
